import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from 'utils/providers/AuthProvider'

import routes from 'constants/routes'

export interface IPublicRouteProps {
  children: React.ReactElement
}

const PublicRoute = ({ children }: IPublicRouteProps) => {
  const { userId } = useAuth()

  if (userId) {
    return <Navigate to={routes.home} />
  }

  return children
}

export default PublicRoute
